<!-- YouTube skippable in-stream video on the TV app -->
<app-tv-frame>
  <!-- START: TV screen -->
  <div class="ytv-ist-screen">
    <!-- START: Creative, full height and centred -->
    <div class="ytv-ist-player">
      <img
        *ngIf="thumbnailUrl; else noCreative"
        class="ytv-ist-creative"
        [src]="thumbnailUrl"
        alt=""
      />

      <ng-template #noCreative>
        <div class="ytv-ist-creative ytv-ist-missing">
          <ng-container *ngIf="isResolving; else askForVideo">
            Reading video format&hellip;
          </ng-container>
          <ng-template #askForVideo>
            Add a video to see this preview
          </ng-template>
        </div>
      </ng-template>
    </div>
    <!-- END: Creative -->

    <!-- Fixed copy: the countdown is the player's, not the author's. -->
    <span class="ytv-ist-chip"><strong>Sponsored</strong> &middot; 00:16</span>

    <!-- START: Footer -->
    <div class="ytv-ist-bar d-flex flex-row align-items-center">
      <img
        class="ytv-ist-logo"
        src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
        alt=""
      />

      <div class="ytv-ist-copy d-flex flex-column">
        <span class="ytv-ist-headline">{{ headline }}</span>
        <span class="ytv-ist-url">{{ displayUrl }}</span>
      </div>

      <!-- The remote's two actions. Fixed copy, as the set draws them. -->
      <div class="ytv-ist-actions d-flex flex-row align-items-center">
        <span class="ytv-ist-pill ytv-ist-send d-flex flex-row align-items-center">
          <i class="bi bi-bell"></i>
          <span>Send to phone</span>
        </span>
        <span class="ytv-ist-pill ytv-ist-skip d-flex flex-row align-items-center">
          <span>Skip Ad</span>
          <i class="bi bi-skip-end-fill"></i>
        </span>
      </div>
    </div>
    <!-- END: Footer -->
  </div>
  <!-- END: TV screen -->
</app-tv-frame>
